import { slicedToArray as _slicedToArray, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';

var skipThisStatuses = [401, 502, 503, 404];
var skipThisCodes = ['AUT_00008', 'AUT_00011', 'AUT_00055', 'VAL_00784', 'CUSTAPP_MISSING_CAPABILITY', 'VAL_01372', 'VAL_01371', 'VAL_01357', 'VAL_00559', 'VAL_01442', 'VAL_00558'];
var shouldLogError = function shouldLogError(err) {
  if (!err || !err.data) {
    return {
      log: false
    };
  }
  var skipCode = skipThisCodes.includes(err.data.errorCode);
  var skipStatus = skipThisStatuses.includes(err.data.status);
  if (skipCode || skipStatus) {
    return {
      log: false
    };
  }
  return {
    log: true,
    errorCode: err.data.errorCode,
    errorGroup: err.data.errorGroup,
    errorMessage: err.data.errorMessage,
    status: err.data.status,
    logTraceId: err.data.logTraceId
  };
};
var SENSITIVE_KEYS = ['giid', 'email', 'mobilePhoneNumber', 'contactId', 'xbnContactId', 'webAccount', 'initials', 'phoneNumber', 'alternativePhoneNumber', 'name', 'phone', 'street', 'address', 'city', 'postalNumber', 'invitation', 'senderName', 'installationAlias', 'invitationId', 'userName', 'password', 'userPassword', 'smsToken'];
var obfuscateVal = function obfuscateVal(key, val) {
  return SENSITIVE_KEYS.includes(key) ? '<Obfuscated>' : val;
};
var loopNestedObj = function loopNestedObj(obj) {
  return Object.fromEntries(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    if (val && _typeof(val) === 'object') {
      return [key, loopNestedObj(val)];
    }
    return [key, obfuscateVal(key, val)];
  }));
};

export { loopNestedObj, shouldLogError, skipThisStatuses };
